export default __webpack_public_path__ + "static/media/profile-locked.b0958753.png";